app.directive("acSwitchSideView", ['$rootScope', function($rootScope) {
    return {
        link: function(scope, element, attributes) {
            element.bind("click", function(event) {
                var views = $(".ac-side-view");
                var target = attributes.acSwitchSideView;
                views.each(function(ind, el){
                    if($(el).attr("id")!=target){
                        $(el).css("display", "none")
                    }else{
                        $(el).css("display", "block")
                    }
                })
            });
        }
    }
}]);